import { a125, a128, a131, a134, a146, a149, a163, a218, a219, a220, a221, a222, a241, a734, a752, a761, rg001 } from "Components/Api/RootApiPath";

export const fetchAllSku = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a163, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchAllStones = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a734, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice list"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    throw error;
  }
};

export const fetchAllLabelledStock = async ({ queryKey }) => {
  const [, clientCode,ItemCode] = queryKey;
  try {
    const data = await fetch(a752, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
        RFIDCode:ItemCode
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch labelled stock list"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw error;
  }
};


export const fetchAllCategories = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch categories"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw new Error(`${"Failed to fetch categories, try again later"}`);
  }
};

export const fetchAllPurities = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a134, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode
      
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch purities"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw new Error(`${"Failed to fetch purities, try again later"}`);
  }
};

export const fetchAllProducts = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode
      
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch products"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw new Error(`${"Failed to fetch products, try again later"}`);
  }
};

export const fetchAllVendors = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a149, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendors"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw new Error(`${"Failed to fetch vendors, try again later"}`);
  }
};

export const fetchAllSKU = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a163, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch sku"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw new Error(`${"Failed to fetch sku, try again later"}`);
  }
};


export const fetchAllDesigns = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a131, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode
      
      }),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch designs"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw new Error(`${"Failed to fetch designs, try again later"}`);
  }
};

export const fetchDataTotalCount = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a761, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch designs"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw new Error(`${"Failed to fetch designs, try again later"}`);
  }
};
export const fetchAllStockReportByCategory = async ({ClientCode,FromDate,ToDate,StockType,PurityId,CategoryId }) => {
  try {
    const data = await fetch(a218, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ClientCode,FromDate,ToDate,StockType,PurityId,CategoryId}),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch stock report"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    console.log(e)
    throw new Error(`${"Failed to fetch stock report, try again later"}`)
  }
};



export const fetchAllStockReportByProduct = async ({ClientCode,FromDate,ToDate,StockType,PurityId,CategoryId, ProductId}) => {
  try {
    const data = await fetch(a219, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ClientCode,FromDate,ToDate,StockType,PurityId,CategoryId, ProductId}),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch stock report"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    console.log(e)
    throw new Error(`${"Failed to fetch stock report, try again later"}`)
  }
};

export const fetchAllStockReportByDesign = async ({ClientCode,FromDate,ToDate,StockType,PurityId,CategoryId, ProductId,DesignId}) => {
  try {
    const data = await fetch(a220, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ClientCode,FromDate,ToDate,StockType,PurityId,CategoryId, ProductId,DesignId}),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch stock report"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    console.log(e)
    throw new Error(`${"Failed to fetch stock report, try again later"}`)
  }
};


export const fetchAllStockReportBySKU = async ({ClientCode,StockType,PurityId,CategoryId, ProductId,DesignId, VendorId,
  StockKeepingUnit}) => {
  try {
    const data = await fetch(a222, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ClientCode,StockType,PurityId,CategoryId, ProductId,DesignId,VendorId,StockKeepingUnit}),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch stock report"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    console.log(e)
    throw new Error(`${"Failed to fetch stock report, try again later"}`)
  }
};

export const fetchAllStockReportBySKUKarigar = async ({ClientCode,StockType,PurityId,CategoryId, ProductId,DesignId, VendorId,
  StockKeepingUnit}) => {
  try {
    const data = await fetch(a221, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ClientCode,StockType,PurityId,CategoryId, ProductId,DesignId,VendorId,StockKeepingUnit}),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch stock report"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    console.log(e)
    throw new Error(`${"Failed to fetch stock report, try again later"}`)
  }
};



export const fetchAllLabelledStockFilter = async ({ ClientCode,CategoryId,ProductId,DesignId,FromDate,ToDate,Content,ItemCode, pageNumber,Status="",SearchQuery=""
 , pageSize}) => {
     
  try {
    const data = await fetch(a752, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: ClientCode,
        CategoryId,
        ProductId,
        DesignId,FromDate,ToDate,
        RFIDCode:ItemCode,
        PageNumber :
        // pageNumber
        0
        ,
        PageSize :
        // pageSize
        0
        ,
        ...(Content && {Content:Content}),
        Status:Status,
        SearchQuery
        
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch labelled stock list"}`
      );
    }
    return data?.json();

  } catch (e) {
    throw error;
  }
};


export const fetchAllStockReportByPackets = async ({ClientCode,FromDate,ToDate,PurityId,CategoryId, ProductId,DesignId}) => {
  try {
    const data = await fetch(a241, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ClientCode,FromDate,ToDate,PurityId,CategoryId, ProductId,DesignId}),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch stock report"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    console.log(e)
    throw new Error(`${"Failed to fetch stock report, try again later"}`)
  }
};


export const fetchAllStockReportByBox = async ({ClientCode,FromDate,ToDate,PurityId,CategoryId, ProductId,DesignId}) => {
  try {
    const data = await fetch(a241, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ClientCode,FromDate,ToDate,PurityId,CategoryId, ProductId,DesignId}),
    });
    console.log(data);
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch stock report"}`
      );
    }
    return data?.json();

    return data;
  } catch (e) {
    console.log(e)
    throw new Error(`${"Failed to fetch stock report, try again later"}`)
  }
};



